import { BrowserRouter, Routes, Route } from "react-router-dom";
import SellerForm from "./pages/SellerForm";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import { ToastContainer } from "react-toastify";
import BuyerForm from "./pages/BuyerForm";
import LeadReferralRewardsForm from "./pages/LeadReferralRewardsForm";
import HomeToRentForm from "./pages/HomeToRentForm";
import StartBuyingHomeForm from "./pages/StartBuyingHomeForm";
import StartSellingHomeForm from "./pages/StartSellingHomeForm";
import LeadReferralRewardsGenericForm from "./pages/LeadReferralGenericForm";
import HomeToRentGenericForm from "./pages/HomeToRentGenericForm";
import MultipleSelectionForm from "./pages/MulipleSelectionForm";
import PropTdealsLandingPage from "./pages/PropTDealsLandingPage";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<PropTdealsLandingPage />} /> */}

        <Route path="/" element={<MultipleSelectionForm />} />
        <Route path="/sellerForm" element={<SellerForm />} />
        <Route path="/buyerForm" element={<BuyerForm />} />
        <Route
          path="/leadReferralRewardsForm"
          element={<LeadReferralRewardsForm />}
        />
        <Route path="/homeToRentForm" element={<HomeToRentForm />} />
        <Route path="/startBuyingHomeForm" element={<StartBuyingHomeForm />} />
        <Route
          path="/startSellingHomeForm"
          element={<StartSellingHomeForm />}
        />
        <Route
          path="/leadReferralGenericForm"
          element={<LeadReferralRewardsGenericForm />}
        />
        <Route
          path="/homeToRentGenericForm"
          element={<HomeToRentGenericForm />}
        />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </BrowserRouter>
  );
};

export default App;
